import {  FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { InputBase } from 'src/app/entidades/inputBase';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogoComponent } from '../dialogo/dialogo/dialogo.component';

@Component({
  selector: 'app-informacoes-adicionais',
  templateUrl: './informacoes-adicionais.component.html',
  styleUrls: ['./informacoes-adicionais.component.css']
})
export class InformacoesAdicionaisComponent implements OnInit {
  formulario: FormGroup;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DialogoComponent>,
    @Inject(MAT_DIALOG_DATA) public inputs: InputBase[]) { }

  ngOnInit(): void {
    this.criarFormulario();
  }

  criarFormulario(): void {
    // 1. Inicialize o FormGroup com o FormArray 'campos'
    let formGroup = new FormGroup({
        campos: new FormArray([]) // 'campos' é o nosso FormArray onde os inputs dinâmicos vão morar
    });

    // 2. Obtenha uma referência ao FormArray
    // Use 'as FormArray' para garantir que o TypeScript saiba que é um FormArray
    const camposFormArray = formGroup.get('campos') as FormArray;

    // 3. Itere sobre os inputs e adicione cada um ao FormArray
    this.inputs.forEach(element => {
        // Define os validadores para o FormControl
        let validators: any[] = [];
        if (element.required) {
            validators.push(Validators.required);
        }
        if (element.email) {
            validators.push(Validators.email);
        }

        // Crie o FormControl para o input atual
        // O valor inicial geralmente é vazio ou um valor padrão, não o nome
        // Se 'element.name' for o valor inicial, mantenha assim.
        // Se for para um campo de input, o valor inicial costuma ser ''
        const control = new FormControl('', validators);

        // Adicione o FormControl ao FormArray
        // Nota: FormArray.push() adiciona um controle como um novo item no array,
        // mas não dá a ele um 'nome' de propriedade dentro do array de forma direta
        // como em um FormGroup. Se você precisa de nomes específicos para cada controle
        // dentro do FormArray, pode ser um FormGroup dentro do FormArray (menos comum para inputs simples).
        // Para inputs simples, geralmente só se empurra o FormControl.
        //
        // Se a intenção é ter um FormGroup dentro do FormArray para cada input (mais robusto):
        // camposFormArray.push(new FormGroup({ [element.name]: control }));
        //
        // Mas para inputs dinâmicos, geralmente se faz assim:
        camposFormArray.push(control);

        // Se você precisa definir o valor após a criação, faça no controle recém-criado
        // control.setValue(element.name); // Se o nome for o valor inicial
    });

    // 4. Atribua o FormGroup final à propriedade do componente
    this.formulario = formGroup;

    // Se você precisar que cada controle dentro do FormArray tenha um 'nome' para acesso fácil
    // (o que não é o padrão de FormArray.push()), você precisaria de uma estrutura diferente,
    // talvez um FormArray de FormGroups, ou reconsiderar a necessidade de 'campos' ser um FormArray.
    //
    // Se a ideia era que os campos fossem propriedades diretas do formGroup (sem o 'campos' FormArray):
    // let formGroup = new FormGroup({}); // Sem o FormArray 'campos'
    // formGroup.addControl(element.name, new FormControl('', validators)); // Isso funcionaria
    // Mas o seu código inicial *definiu* 'campos' como um FormArray.
}

  getId(name: string): string {
    return `input${name}`;
  }

  getClass(input: InputBase): string {
    return `{'width': ${input.width}px !important;}`;
  }

  onSubmit(): void {
    this.dialogRef.close(this.formulario);
  }

  cancelar(): void {
    this.dialogRef.close();
  }

  getMaxLength(maxLenght: number): number {
    return maxLenght === 0 ? 100 : maxLenght;
  }
}
